// The numbers on a signup's stats page, from what the app really counts.
//
// Visits and submits are the signup's own totals. Opens and confirms come from
// its signup emails only: a follow-up email isn't part of signing up.
//
// Sends aren't counted for signup emails, so the open rate is opens per submit:
// each submit sends one signup email. Opens count every time the email is
// loaded, so one person can count more than once.
export function campaignStats(campaign) {
  const signupEmails = ((campaign && campaign.mail_variants) || []).filter((m) => m.role !== "followup");
  const total = (field) => signupEmails.reduce((sum, m) => sum + (m[field] || 0), 0);
  return {
    formVisits: (campaign && campaign.views) || 0,
    formSubmits: (campaign && campaign.conversions) || 0,
    emailOpens: total("opens"),
    emailConfirms: total("conversions"),
  };
}
